import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CategorieService } from '../../../../services/categorie.service';
import { AuthService } from '../../../../services/auth.service';
import { Router } from '@angular/router';
import { BCategory, IBCategory } from '../../../../models/b-category.model';
import Swal from 'sweetalert2';
import { nameValidator } from '../../validators/validator';

@Component({
  selector: 'app-categorie',
  templateUrl: './categorie.component.html',
  styleUrls: ['./categorie.component.scss']
})
export class CategorieComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  categories = [];
  categoriesTmp = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  currentCategory: BCategory;

  perPage = 10;

  constructor(private categorieService : CategorieService,
              private fb: FormBuilder,private authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadCategories();
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  // Only AlphaNumeric
  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  get f2() { return this.categorieForm.controls; }

  categorieForm = this.fb.group({
      //'name': ['', { validators: nameValidator('Le nom de la catégorie', 2, 50), updateOn: 'change'}],
      'name': ['', Validators.required],
      'description': ['', [Validators.minLength(10), Validators.maxLength(255)]],
    }
  );

  updateCategoryForm = this.fb.group({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.minLength(10), Validators.maxLength(255)])
      //'name': ['', { validators: nameValidator('Le nom de la catégorie', 2, 50), updateOn: 'change'}],
      //'name': ['', Validators.required],
      //'description': ['', [Validators.minLength(10), Validators.maxLength(255)]],
    }
  );

  get name() { return this.updateCategoryForm.get('name'); }
  get description() { return this.updateCategoryForm.get('description'); }

  model = {
    name: '',
    description: ''
  };

  loadCategories(){
    this.categorieService.getAllCategories().subscribe(rs=>{
      this.categories = rs;
      this.categoriesTmp = rs;
      //console.log("Liste des catégories");
      //console.log(rs);
    });
  }

  onSubmit(){
    if(this.categorieForm.valid){
      let category = new BCategory();
      const categoriyInfo1: BCategory = this.categorieForm.value;
      //console.log(categoriyInfo1);
      category.name = this.model.name;
      category.description = this.model.description;
      //console.log(category);
      this.categorieService.saveCategorie(category).subscribe(rs=>{
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Catégorie ajoutée avec succés',
          showConfirmButton: false,
          timer: 2500
        });
        this.loadCategories();
        this.reloadComponent();
        this.close();
      },error => {
        //console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Erreur lors de l\'ajout de la catégorie',
          showConfirmButton: false,
          timer: 1500
        });
      });
    }
  }

  //ça permet d'actualiser le composant
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  onSubmitEditForm(){
    //const categoriyInfo1: BCategory = this.updateCategoryForm.value;
    this.updatedCategory.name = this.updateCategoryForm.get('name').value;
    this.updatedCategory.description = this.updateCategoryForm.get('description').value;
    this.categorieService.updateCategorie(this.updatedCategory).subscribe(rs=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Catégorie modifiée avec succés',
        showConfirmButton: false,
        timer: 2500
      });
      this.loadCategories();
      this.reloadComponent();
      this.close();
    },error => {
      //console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la catégorie',
        showConfirmButton: false,
        timer: 1500
      });
    });

  }

  onViewCategory(cat: any) {
    this.categorieService.getCategoryById(cat.id).subscribe(category =>  {
      this.currentCategory = category;
      // console.log("Détails categorie.....");
      // console.log(this.currentCategory);
    });
  }

  updatedCategory: BCategory;
  editCategory(cat: BCategory){
    this.updatedCategory = cat;
    this.updateCategoryForm.patchValue({
      name: cat.name,
      description: cat.description
    })
    /*this.categorieForm = this.fb.group({
      name : new FormControl(cat.name, { validators: nameValidator('Le nom de la catégorie', 2, 50), updateOn: 'change'}),
      description : new FormControl(cat.description, [Validators.minLength(10), Validators.maxLength(255)]),
    })*/
  }

  deleteCategory(cat: IBCategory){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette catégorie ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.categorieService.deleteCategorie(cat.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Catégorie supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadCategories();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }
}
